/**
 * Loading Spinner Component
 *
 * A refined loading indicator with Guild brand colors.
 * Supports multiple sizes for different contexts.
 */

import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeConfig = {
  sm: { iconSize: 16, strokeWidth: 2.5 },
  md: { iconSize: 24, strokeWidth: 2.5 },
  lg: { iconSize: 32, strokeWidth: 2 },
};

export function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  const { iconSize, strokeWidth } = sizeConfig[size];

  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      role="status"
      aria-label="Loading"
    >
      <Loader2
        size={iconSize}
        strokeWidth={strokeWidth}
        className="animate-spin text-guild-green"
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
}
